import isBrowser from 'src/util/isBrowser'

const localStorageWrapper = {
  getItem: (key, defaultValue) => {
    if (isBrowser() && window.localStorage) {
      const item = window.localStorage.getItem(key)
      // localStorage.getItem only returns null if the item does not exist
      // it is not possible to store the literal `null`, only "null"
      if (item !== null) {
        return item
      }
    }
    // return the default or undefined if no default has been set
    return defaultValue
  },
  setItem: (key, value) => {
    if (!isBrowser()) {
      return false
    }
    try {
      // if the user is using private mode on
      // safari, localStorage is disabled
      localStorage.setItem(key, value)
    } catch (e) {}
  },
  removeItem: (key) => {
    if (!isBrowser()) {
      return false
    }
    try {
      // if the user is using private mode on
      // safari, localStorage is disabled
      localStorage.removeItem(key)
    } catch (e) {}
  },
}

export default localStorageWrapper
